import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

function getCurrentStoreId() {
  try {
    const user = JSON.parse(localStorage.getItem('userInfo') || '{}')
    return user.storeId || ''
  } catch (e) {
    return ''
  }
}

// 查询待审批加班列表
export function listAttendanceOvertimeAudits(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attendanceOvertime.listAttendanceOvertimeAudits',
      method: 'post',
      data: {
        ...params,
        storeId: getCurrentStoreId() || params.storeId,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      // 后端格式：ResultVo.createResponseEntity(code, msg, new Object[]{list, total})
      // 即 res.data = [list, total]，所以 res.data[0] 是记录数组，res.data[1] 是 total
      const rawData = res.data || []
      const listData = Array.isArray(rawData[0])
        ? rawData[0]
        : (Array.isArray(rawData) ? rawData : [])
      const totalCount = typeof rawData[1] === 'number'
        ? rawData[1]
        : (res.records || res.total || 0)
      resolve({
        data: listData,
        total: totalCount
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 审批加班
export function auditAttendanceOvertime(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attendanceOvertime.auditAttendanceOvertime',
      method: 'post',
      data: {
        ...data,
        storeId: getCurrentStoreId() || data.storeId,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询加班历史列表
export function listAttendanceOvertimes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attendanceOvertime.queryAttendanceOvertimes',
      method: 'post',
      data: {
        ...params,
        storeId: getCurrentStoreId() || params.storeId,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      // 后端格式：ResultVo.createResponseEntity(code, msg, new Object[]{list, total})
      // 即 res.data = [list, total]，所以 res.data[0] 是记录数组，res.data[1] 是 total
      const rawData = res.data || []
      const listData = Array.isArray(rawData[0])
        ? rawData[0]
        : (Array.isArray(rawData) ? rawData : [])
      const totalCount = typeof rawData[1] === 'number'
        ? rawData[1]
        : (res.records || res.total || 0)
      resolve({
        data: listData,
        total: totalCount
      })
    }).catch(error => {
      reject(error)
    })
  })
}
